export const FEATURE_NAME = '@zerops/zerops/feature/deploy-shutdown-dialog';
